export const FETCH_DETAILS = 'reconciliationReceiptBonusDetails/FETCH_DETAILS';
